module.exports = __webpack_public_path__ + "img/2024_MRC_Symposium_HK.a505ebc5.jpg";